import React, { useContext, useEffect } from "react";
import { AuthContext } from "../AuthContext";
import { UserContext } from "../UserContext";
import { useNavigate } from "react-router-dom";

const ProfileContent: React.FC = () => {
  const { session, role } = useContext(AuthContext);
  const { user } = useContext(UserContext);

  const navigate = useNavigate();

  useEffect(() => {
    navigate("my-team");
  }, []);

  return (
    <div>
      <h1 className="text-2xl mt-10 text-center text-white">
        Welcome, {user?.name}
      </h1>
      {role === "ADMIN" && <div className="text-white">Hello Admin</div>}
    </div>
  );
};

export default ProfileContent;
